import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import { Elements } from 'react-stripe-elements';
import { withSizes } from 'react-sizes';
import { PaymentWizardPass, SessionTimer, PaymentForm } from '../index';
import PassPanel from '../PassPanel';

import {
  CheckoutContainer,
  Column,
  PageHeading,
  Heading,
  SubHeading,
} from './styles';

const { PanelContainer, PanelImageContainer, PaymentInfo } = PassPanel;

const mapSizesToProps = ({ width }) => ({
  isTablet: width >= 768,
});

@withSizes(mapSizesToProps)
@withRouter
class CheckoutPassWrapper extends PureComponent {
  static propTypes = {
    isTablet: PropTypes.bool,
    name: PropTypes.string,
    planName: PropTypes.string,
    image: PropTypes.string,
    router: PropTypes.instanceOf(Object),
  };

  state = {
    form: null,
  };

  getForm = instance => {
    this.setState({
      form: instance,
    })
  };

  onTimeExpiry = () => {
    const { router } = this.props;
    router.push('/')
  };

  render() {
    const { getForm, onTimeExpiry } = this;
    const { form } = this.state;
    const { isTablet, name, planName, image } = this.props;

    return (
      <CheckoutContainer as="main">
        <Column>
          <PageHeading>
            <Heading>
              <span>Dayaxe</span> {name}
            </Heading>
            <SubHeading>Confirm and pay</SubHeading>
            {typeof window !== 'undefined' && <SessionTimer product={name} onTimeExpiry={onTimeExpiry} />}
          </PageHeading>
          {!isTablet && <PanelImageContainer />}
          <Elements>
            <PaymentForm>
              <PaymentWizardPass setFormikInstance={getForm} planName={planName} />
            </PaymentForm>
          </Elements>
          {!isTablet && <PaymentInfo total={25000} subtotal={25000} formInstance={form} {...this.props} />}
        </Column>
        <Column>
          {isTablet && (
            <PanelContainer>
              <PanelImageContainer image={image} />
              <PaymentInfo total={25000} subtotal={25000} formInstance={form} {...this.props} />
            </PanelContainer>
          )}
        </Column>
      </CheckoutContainer>
    );
  }
}

export default CheckoutPassWrapper;
